

import React, { Component } from 'react';
import { Card, CardBody, CardTitle, CardSubtitle, CardText, Col, Container, Row, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import showResults from '../Show';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import * as myConstClass from '../../../constant.js';
import 'font-awesome/css/font-awesome.min.css';
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";

const { SearchBar } = Search;
const tableColumns = [
  {
    dataField: "id",
    text: "#",
    sort: true,
    headerStyle: { width: "5%" }
  },
  {
    dataField: "tenant_name",
    text: "Tenant Name",
    sort: true,
    headerStyle: { width: "15%" }
  },
  {
    dataField: "keyword",
    text: "Keyword",
    sort: true,
    headerStyle: { width: "25%" }
  },
  {
    dataField: "action",
    text: "Action",
    headerStyle: { width: "10%" },
    csvExport: false
  },
];
class Tenant_Keyword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: [],
    }
    this.flag = 0;
    this.customLabels = {
      first: '<<',
      last: '>>',
      prev: '<',
      next: '>',
      show: 'Display',
      entries: 'rows',
      noResults: 'There is no data to be displayed',
    };
    this.handleChange = this.handleChange.bind(this);
  }

  view(e) {
    this.props.history.push('/forms/view_tenant_keyword/' + e);
  }

  handleChange(event) { }

  add_tenant_keyword() {
    this.props.history.push('/forms/add_tenant_keyword');
  }

  onSortFunction = {
    date(columnValue) {
      // Convert the string date format to UTC timestamp
      // So the table could sort it by number instead of by string
      return moment(columnValue, 'Do MMMM YYYY').valueOf();
    },
  };

  componentDidMount() {
    var tid = 1;
    if (localStorage.getItem('uid')) {
      tid = localStorage.getItem('uid');
    }

    fetch(myConstClass.BASE_URL + '/user/getTenantKeyword')
      .then(response => response.json())
      .then(response => {
        let i = 1;
        response.forEach(element => {
          var id = element.uid;
          element.action = <div><center><i id={id} className="fa fa-eye ptr_css" onClick={() => this.view(id)}></i>&nbsp;&nbsp;</center></div>;
          element.id = i;
          i++;
        });
        this.setState({ formData: response })
      }).catch(err => console.log(err))
    if (!localStorage.getItem('session_id')) {
      this.props.history.push('/log_in');
    }
  }

  render() {
    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">All Tenant Keyword</h3>
          </Col>
          <ToastContainer enableMultiContainer containerId={'A'} position={toast.POSITION.BOTTOM_LEFT} />
          <ToastContainer enableMultiContainer containerId={'B'} position={toast.POSITION.TOP_RIGHT} />
        </Row>
        <Row>
          <Col md={12} lg={12}>
            <Card>
              <ToolkitProvider keyField="name" data={this.state.formData} columns={tableColumns} exportCSV search >
                {props => (
                  <div>
                    <CardBody>
                      <Row></Row>
                      <Button color="primary" style={{ float: 'right' }} onClick={() => this.add_tenant_keyword()} > Add Keyword</Button>
                      <SearchBar {...props.searchProps} />
                      <BootstrapTable
                        {...props.baseProps}
                        bootstrap4
                        bordered={false}
                        pagination={paginationFactory({
                          sizePerPage: 10,
                          sizePerPageList: [5, 10, 25, 50]
                        })}
                      />
                    </CardBody>
                  </div>
                )}
              </ToolkitProvider>
            </Card>
          </Col>
        </Row>
      </Container>)
  }
}

export default withTranslation('common')(Tenant_Keyword);
